import { render } from "./OnboardingFlow.vue?vue&type=template&id=c2979fec&scoped=true"
import script from "./OnboardingFlow.vue?vue&type=script&lang=js"
export * from "./OnboardingFlow.vue?vue&type=script&lang=js"

import "./OnboardingFlow.vue?vue&type=style&index=0&id=c2979fec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2979fec"]])

export default __exports__